<!--
 * @Author: your name
 * @Date: 2021-06-30 18:09:19
 * @LastEditTime: 2021-08-07 15:00:31
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\TASMini\views\Im\chooseList.vue
-->
<template>
<div style="position:relative" class="outbox">
    <div class="box">
        <!-- 分组 -->
        <a-tabs default-active-key="1" @change="callback">
            <a-tab-pane key="1" tab="客户">
                <div class="mians">
                    <div class="msg-t">
                        <div class="friend-list" v-for="(item,index) in grouping" :key="index"
                            v-if="item.groupName == '我的客户'">
                            <div v-for="(item,index) in item.friendListModel" :key="index">
                                <div class="aa">
                                    <div class="friend-list-l">
                                        <img :src="item.imageUrl" alt="">
                                    </div>
                                    <div class="friend-list-rs">
                                        <div class="top">
                                            <div class="name">{{item.imAccount}}</div>
                                        </div>
                                        <div class="news">{{item.imName}}</div>
                                    </div>
                                    <div class="chenck" :class="item.checked ?'chenckboxx' : ''"
                                        @click="radios(index,item.imAccount)"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </a-tab-pane>
            <a-tab-pane key="2" tab="门店" force-render>
                <div class="msg-t">
                    <div v-for="(item,index) in grouping1" :key="index">
                        <div class="fold__items">
                            <div @click="listDataClick(index)">{{item.groupName}}</div>
                            <div v-if="item.isSelect">
                                <div v-for="(itemA,indexs) in item.friendListModel" :key="indexs"
                                    class="fold__item--content">
                                    <div class="friend-list-ls">    
                                        <img :src="itemA.imageUrl" alt="">
                                    </div>
                                    <div class="friend-list-rs">
                                        <div class="top">
                                            <div class="name">{{itemA.imAccount}}</div>
                                        </div>
                                        <div class="news" v-if="itemA.imName != null">{{itemA.imName}}</div>
                                    </div>
                                    <div class="chenck" :class="{chenckboxx:itemA.checked}"
                                        @click="radiox(index,indexs,itemA.imAccount)"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </a-tab-pane>
            <a-tab-pane key="3" tab="团队">
                <div class="mians">
                    <div class="msg-t">
                        <div class="friend-list" v-for="(item,index) in grouping" :key="index"
                            v-if="item.groupName == '我的同事'">
                            <div v-for="(item,index) in item.friendListModel" :key="index">
                                <div class="aa">
                                    <div class="friend-list-l">
                                        <img :src="item.imageUrl" alt="">
                                        <!-- <img src="../../../TASMini/assets/images/crown45.png" alt="" srcset=""> -->
                                    </div>
                                    <div class="friend-list-rs">
                                        <div class="top">
                                            <div class="name">{{item.imAccount}}</div>
                                        </div>
                                        <div class="news">{{item.imName}}</div>
                                    </div>
                                    <div class="chenck" :class="{chenckboxx:item.checked}"
                                        @click="radio(index,item.imAccount)"></div>
                                </div>
                                <span v-show="false"> {{checkedList}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </a-tab-pane>
        </a-tabs>
        <!-- <div class="select">
            {{checkedList}}
            <div class="chenckbox" :class="{chenckboxs:selec}" @click="selecAll"></div>
            <div class="determine" @click="determine">发送</div>
            <div class="determine" @click="determine">取消</div>
        </div> -->
    </div>
    <div class="shareContT">
        <span style="float:left;color:black;font-weight:bold">分别转发给:</span>
        <span>已选择 {{checkedList.length || 0}}个聊天</span>
            <div class="chenckbox" :class="{chenckboxs:selec}" @click="selecAll"></div>全选
    </div>
    <div class="box2">
        <div class="shareContC">
            <div v-for="(item,index) in checkedList" :key="index">
                <div class="aa" style="zoom:0.8">
                    <div class="friend-list-l">
                        <!-- <img src="../../assets/images/head.jpg" alt=""> -->
                        <img :src="item.imageUrl" alt="">
                    </div>
                    <div class="friend-list-rs" style="margin-left:15px">
                        <div class="top">
                            <div class="name">{{item.imAccount}}</div>
                        </div>
                        <div class="news">{{item.imName}}</div>
                    </div>
                   
                </div>
                <span v-show="false"> {{checkedList}}</span>
            </div>
        </div>
    </div>
        <div class="btnbox">          
            <div class="determine" style="background:#1aad19;color:white" @click="determine">发送</div>
            <div class="determine" @click="determine2">取消</div>
        </div>
</div>
</template>
<script>
    import { getGroupFriend, getOrgGroupFriend,sendBatchCustomMsg,batchSendMsg} from '../../api/im.js'
    export default {
        data() {
            return {
                selec: false,
                grouping: [
                    {
                        friendListModel: [
                            {
                                imAccount: "217136292",
                                imName: "销售--组长01"
                            },
                            {
                                imAccount: "217138888",
                                imName: "销售--组长03"
                            }
                        ],
                        groupName: "我的同事"
                    },
                    {
                        friendListModel: [
                            {
                                imAccount: "217136666",
                                imName: "销售--组长02"
                            }
                        ],
                        groupName: "我的客户"
                    }
                ],
                grouping1: [
                    
                ],
                checkedList: [],//选中的值
                showIndex: -1,
            }
        },
        props:{
            data:{
                type:Object,
                default(){
                    return {}
                }
            },
            type:{
                type:Number,
                default:0   // 1甩位消息
            }
        },
        created() {
            if(this.$route.query.isEntry == null){

                this.getGroupFriend()
                this.getOrgGroupFriend()
            }

            this.grouping.forEach(item => {
                if (item.friendListModel != null) {
                    item.friendListModel.forEach(itemA => {
                        itemA.checked = false
                    })
                }
            })
            this.grouping = this.grouping
        },
        methods: {
            callback(key) {
                // console.log(key);
            },
            determine2(){
                this.$emit('success',true)
            },
            // 确定
            determine() {
                if (this.checkedList.length <= 0) {
                    this.$message.warning('至少选择一个');
                } else {
                    var that = this
                    var accountList = that.checkedList.map(item=>item.imAccount)
                    var data = that.data;
                    var messageText = {
                        "from_Account": localStorage.getItem('imAccount'),
                        "to_Account":accountList ?accountList :accountList[0],
                        "msgBody": [
                            {
                            "msgType": "TIMTextElem",
                            "msgContent": {
                                "text": data.shareImMessage
                            }
                            }
                        ]
                    }
                    batchSendMsg(messageText).then(res2=>{
                            console.log('自定义的发1')

                            var messages = {
                                "batchSendMsgVO": {
                                    "from_Account": localStorage.getItem('imAccount'),
                                    "to_Account":accountList ?accountList :accountList[0],
                                    "msgBody": [{
                                        "msgType": "TIMCustomElem",
                                        "msgContent": {
                                            "data": ""
                                        }
                                    }]
                                },
                                "customVo": {
                                    "productDescription": data.productDetail.productTitle,
                                    "url": "",
                                    "imageUrl": data.productDetail.imageHeadUrl,
                                    "shopCode": "",
                                    "productCode": data.productDetail.productCode,
                                    "userCode": "",
                                    "orgCode": "",
                                    "businessAreaCode": data.productDetail.businessAreaCode,
                                    "businessAreaType": data.productDetail.businessAreaType,
                                    "productTypeId": data.productDetail.productType,
                                    "price": data.productDetail.adultAdvisePriceMin,
                                    "origin": data.productDetail.fromCityName,
                                    "destination": data.productDetail.toCityName,
                                    "productSource": "2",
                                    "productShare": "2"
                                }
                            }
                            console.log('自定义的发2')
                            sendBatchCustomMsg(messages).then(res=>{
                                // console.log(res,'自定义消息发送')
                                
                                this.$message.success('分享信息成功!')
                                that.$emit('success',true)
                            })
                    })
                    
                }
            },

            // 全选
            selecAll() {
                this.selec = !this.selec
                if (this.selec == true) {
                    this.checkedList = []
                    this.$message.success('已全部选中');
                    this.grouping.forEach(item => {
                        if (item.friendListModel != null) {
                            item.friendListModel.forEach(itemA => {
                                this.checkedList.push(itemA)
                                itemA.checked = true
                            })
                        }
                    })
                    this.grouping1.forEach(item => {
                        if (item.friendListModel != null) {
                            item.friendListModel.forEach(itemA => {
                                this.checkedList.push(itemA)
                                itemA.checked = true
                            })
                        }
                    })

                } else {
                    this.$message.warning('已取消全部选中');
                    this.grouping.forEach(item => {
                        if (item.friendListModel != null) {
                            item.friendListModel.forEach(itemA => {
                                // this.checkedList.push(itemA.imAccount)
                                itemA.checked = false
                                this.checkedList = []
                            })
                        }
                    })
                    this.grouping1.forEach(item => {
                        if (item.friendListModel != null) {
                            item.friendListModel.forEach(itemA => {
                                // this.checkedList.push(itemA.imAccount)
                                itemA.checked = false
                                this.checkedList = []
                            })
                        }
                    })
                }
            },

            // 单选 客户
            radio(index, event) {
                this.grouping[0].friendListModel.forEach((item, indexs) => {
                    if (index == indexs) {
                        if (item.checked == true) {
                            item.checked = false
                            var arr = this.checkedList.filter(item => item.imAccount == event);
                            this.checkedList.splice(arr, 1);
                        } else {

                            item.checked = true
                            this.checkedList.push(item)
                        }
                    }
                })
            },

            // 单选 团队
            radios(index, event) {
                // console.log(index, event)
                this.grouping[1].friendListModel.forEach((item, indexs) => {
                    if (index == indexs) {
                        if (item.checked == true) {
                            item.checked = false
                            var arr = this.checkedList.filter(item => item.imAccount == event);
                            this.checkedList.splice(arr, 1);
                        } else {
                            item.checked = true
                            this.checkedList.push(item)
                        }
                    }
                })
            },
            // 单选 供应商
            radiox(indexYi, indexEr, event) {
                // console.log(indexYi, '==---------------==', indexEr)
                this.grouping1.forEach((item, indexs) => {
                    if (indexYi == indexs) {
                        if (item.friendListModel != null) {
                            item.friendListModel.forEach((itemA, indexd) => {
                                if (indexEr == indexd) {
                                    if (itemA.checked == true) {
                                        itemA.checked = false
                                        var arr = this.checkedList.filter(item => item.imAccount == event);
                                        this.checkedList.splice(arr, 1);
                                    } else {
                                        itemA.checked = true
                                        this.checkedList.push(itemA)
                                    }
                                }
                            })
                        }
                    }
                })
            },

            // 折叠面板
            listDataClick(e) {
                console.log(e, '点击下标')
                this.grouping1.forEach((item, index) => {
                    if (e == index) {
                        item.isSelect = !item.isSelect
                    }
                })
            },

            // 获取好友列表
            getGroupFriend() {
                var that = this
                var data = {
                    from_Account: localStorage.getItem('imAccount'),
                    needFriend: "Need_Friend_Type_Yes",
                    lastSequence: 0,
                }
                getGroupFriend(data).then(res => {
                    that.grouping = res.groupListModel
                    // console.log(that.grouping, '88888888888')
                })
            },

            // 获取供应商列表
            getOrgGroupFriend() {
                var that = this
                var data = {
                    from_Account: localStorage.getItem('imAccount'),
                    needFriend: "Need_Friend_Type_Yes",
                    lastSequence: 0,
                }
                getOrgGroupFriend(data).then(res => {
                    // console.log(res, '00000000000000000000000000000000')
                    res.forEach(item=>{
                        item.isSelect = false
                    })
                    this.grouping1 = res
                })
            },
        }
    }
</script>
<style scoped>
.outbox{
    width: 665px;
    border-radius: 10px;
    overflow: hidden;
    background: white;
}
    .box {
        width: 365px;
        height: 550px;
        background-color: white;
        /* background-color: #dfdfdf; */
        /* background-color:red; */
        border-right: 1px solid #ccc;

    }
    .box2{
          width: 300px;
        height: 550px;
        left: 365px;
        /* background: pink; */
        /* background-color: #dfdfdf; */
        position: absolute;
        background: white;
        top: 0;
        overflow-y:scroll ;
        padding:30px;
        /* padding-top: 70px; */
        margin-top: 70px;
    }
    .shareContT{
        text-align: right;
        position: absolute;
        top: 0px;
        width: 300px;
        height: 50px;
        right: 0;
        z-index: 3;
        padding: 30px;

    }
    .shareContC{
        margin-top: 20px;
    }
    .btnbox{
        position: absolute;
        bottom: 20px;
        right: 30px;
    }
    /deep/ .ant-tabs-tab {
        width: 100px;
        text-align: center;
    }

    /deep/ .ant-tabs-nav .ant-tabs-tab-active {
        width: 100px;
        text-align: center;
    }

    .select {
        width: 100%;
        height: 50px;
        position: absolute;
        bottom: -20px;
        background-color: #ebebeb;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        display: flex;
        flex-direction: row;
        border-top: 1px solid rgb(209, 209, 209);
    }

    .msg-t {
        height: 500px;
        margin-top: -14px;
        overflow: auto;
    }

    .msg-t::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 5px;
        /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
    }

    .msg-t::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 10px;
        box-shadow: inset 0 0 5px rgb(201, 201, 201);
        background: rgb(255, 255, 255);
    }

    .msg-t::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        box-shadow: inset 0 0 5px rgb(201, 201, 201);
        border-radius: 5px;
        background: #ededed;
    }

    .determine {
        display: inline-block;
        text-align: center;
        cursor: pointer;
        border: 1px solid #ccc;
        height: 30px;
        width: 70px;
        line-height: 30px;
        
    }

    .chenckbox {
        display: inline-block;
        width: 20px;
        height: 20px;
        border: 1px solid #333;
        border-radius: 3px;
        margin: 15px 5px 0 140px;
    }

    .chenckboxs {
        display: inline-block;
        width: 20px;
        height: 20px;
        border: 1px solid #333;
        background-color: rgb(70, 180, 180);
        border-radius: 3px;
        margin: 15px 5px 0 140px;

    }

    .mians {
        width: 100%;
        padding-top: 0px;
    }

    .friend-list {
        background: #e7e7e7;
        padding: 15px 5px;
    }

    .aa {
        display: flex;
        flex-direction: row;
        margin-bottom: 8px;
    }

    .friend-list-l {
        float: left;
        position: relative;
        width: 12%;
    }

    .friend-list-l img {
        width: 40px;
        height: 40px;
        border-radius: 8px;
        margin-top: 0px;
    }

    .friend-list-rs {
        padding-left: 10px;
        width: 70%;
    }

    .top {
        height: 25px;
        /* margin-left: -41px; */
    }

    .name {
        float: left;
        font-size: 16px;
        font-weight: 400;
        color: #333;
        line-height: 25px;
        /* margin-top: -100rpx; */
    }

    .news {
        font-size: 14px;
        color: rgb(167, 167, 167);
        /* margin-left: -30px; */
        line-height: 20px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        height:25px;
    }

    .chenck {
        width: 20px;
        height: 20px;
        border: 1px solid #333;
        border-radius: 3px;
        margin-top: 10px;
    }

    .chenckboxx {
        width: 20px;
        height: 20px;
        border: 1px solid #333;
        background-color: steelblue;
        border-radius: 3px;
        margin-top: 10px;
    }

    .fold__item--content {
        margin-top: 15px;
        transition: all 0.4s;
        display: flex;
        flex-direction: row;
    }

    .friend-list-ls {
        float: left;
        position: relative;
        width: 15%;
        height: 52px;
    }

    .friend-list-ls img {
        width: 40px;
        height: 40px;
        border-radius: 8px;
        margin-top: 0px;
        /* margin-left: 18px; */
    }

    .friend-list-rs {
        padding-left: 0px;
        margin-top: -5px;
    }

    .fold__items {
        background: #f1f1f1;
        box-shadow: -6px 0px 20px 0px #E7E7E7;
        border-radius: 10px;
        margin-bottom: 15px;
        padding: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/SRM/views/Im/chooseList.vue